export const paths = {
    profileUser: '/nft/profile/',
    profileAddress: '/nft/address/ethereum/',
} as const;

export const coverImageUploaderReqs = {
    cropShape: 'rect' as const,
    targetHeight: 220,
    targetWidth: 1440,
    aspect: 1440 / 220,
};

export const avatarImageUploaderReqs = {
    cropShape: 'round' as const,
    targetHeight: 200,
    targetWidth: 200,
    aspect: 200 / 200,
};
